<template>
  <div>
    <header class="section-header section-header-news mb-3">
      <h3 class="text-transparencia">
        NOTICIAS
      </h3>
      <hr style="border-top-color: rgba(0, 0, 0, 0.15) !important;" />
    </header>

    <div id="slider-noticias-voluntariado">
      <template v-for="(noticia, index) in noticias">
        <div class="pl-2 pr-2" :key="index">
          <div class="card card-frame card-owework border hover-shadow-9 transition-hover">
            <div class="card-img-top w-100 text-center">
              <a :href="'home/noticia/' + noticia.noticiaId">
                <img class="img-fluid w-100 rounded cimage-slider" :src="`${filesUrl + noticia.rutaImagenMiniatura}`" :alt="noticia.titulo" />
              </a>
            </div>
            <div class="card-body p-2">
              <div class="d-flex justify-content-center text-center" style="height:6.6rem !important;overflow:hidden">
                <a :href="'home/noticia/' + noticia.noticiaId">
                  <h6 class="card-title fs-15 text-transparencia">{{ noticia.titulo }}</h6>
                </a>
              </div>
            </div>
            <div class="card-footer text-right pt-0">
              <a class="fs-13 fw-600 anim-link-2 anim-link-2-primary" :href="'home/noticia/' + noticia.noticiaId">Leer más<i class="fa fa-search-plus ml-1"></i></a>
            </div>
          </div>
        </div>
      </template>
    </div>
    <div class="col-md-12 text-center mt-4">
      <router-link to="/home/noticias" class="btn btn-primary">Ver todo</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "view-noticias-voluntariado",
  components: {},
  data: () => ({
    noticias: [],
  }),
  methods: {
    fetchNews: function() {
      this.$http.get(this.apiRoute("Common", "ListNoticiasAll")).then(function(response) {
        if (!response.body.error) {
          this.noticias = response.body.data;
        }
        startSlider("slider-noticias-voluntariado", [4, 3, 3, 2, 2, 1]);
      });
    },
  },
  mounted: function() {
    this.fetchNews();
  },
};
</script>

<style scoped>
.section-header-news {
  text-align: center;
}

.section-header-news h3 {
  font-size: 2rem;
  font-weight: 800;
  margin-bottom: 0.5rem;
}

.section-header-news hr {
  width: 60px;
  margin: 0 auto;
  border-top: 3px solid #2484da;
}

.btn-transparencia {
  background-color: #2484da !important;
  border-color: #2484da !important;
  color: white !important;
}

.btn-transparencia:hover {
  background-color: #1e6bb8 !important;
  border-color: #1e6bb8 !important;
}

/* Estilos para el carrusel */
.slick-prev:before,
.slick-next:before {
  color: #2484da !important;
}

.slick-prev {
  left: -25px;
}

.slick-next {
  right: -25px;
}

/* Forzar layout horizontal desde el inicio para evitar apilamiento */
#slider-noticias-voluntariado {
  display: flex !important;
  overflow-x: hidden;
}

#slider-noticias-voluntariado .pl-2 {
  flex-shrink: 0;
  width: 25%; /* Para 4 elementos por fila */
}

/* Responsive */
@media (max-width: 768px) {
  .slick-prev,
  .slick-next {
    display: none !important;
  }
}
</style>
